import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getOperationalSubmission = createAsyncThunk(
  "admin/operational-submission",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/admin/operational-submission", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getOperationalSubmissionById = createAsyncThunk(
  "admin/operational-submission/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/admin/operational-submission/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortOperationalSubmission = createAsyncThunk(
  "admin/operational-submission/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/admin/operational-submission/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const postOperationalSubmission = createAsyncThunk(
  "admin/operational-submission/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/admin/operational-submission", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteOperationalSubmission = createAsyncThunk(
  "admin/operational-submission/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/admin/operational-submission/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateOperationalSubmission = createAsyncThunk(
  "admin/operational-submission/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/admin/operational-submission",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const operationalSubmissionSlice = createSlice({
  name: "Operational Submission Store",
  initialState: initialState,
  reducers: {
    addOperationalSubmission(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortOperationalSubmission(state, action) {
      state.data.docs = action.payload;
    },
    deleteOperationalSubmission(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editOperationalSubmission(state, action) {
      let x = state.data.docs.findIndex((item) => item._id === action.payload._id);
      state.data.docs[x] = action.payload;
    },
  },
  extraReducers: {
    [getOperationalSubmission.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getOperationalSubmission.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getOperationalSubmission.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getOperationalSubmissionById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getOperationalSubmissionById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getOperationalSubmissionById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortOperationalSubmission.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortOperationalSubmission.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortOperationalSubmission.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postOperationalSubmission.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postOperationalSubmission.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postOperationalSubmission.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteOperationalSubmission.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteOperationalSubmission.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteOperationalSubmission.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateOperationalSubmission.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateOperationalSubmission.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateOperationalSubmission.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const operationalSubmissionActions = operationalSubmissionSlice.actions;

export default operationalSubmissionSlice.reducer;
